<template>
  <el-pagination background :total="total" :current-page="pagination.currentPage" :page-size="pagination.pageSize" :page-sizes="pagination.pageSizes" :layout="pagination.layout" @size-change="onPageSizeChange" @current-change="onPageCurrentChange" />
</template>

<script>
import { isNil, cloneDeep } from 'lodash';
import { defaultPagination } from '@/constants/table';

export default {
  name: 'WPagination',
  props: {
    /**
     * 데이터 총 개수
     */
    total: {
      type: Number,
      default: 0,
    },
    /**
     * 페이지 파라미터와 함께 전달할 파라미터 객체
     * @type {Object}
     */
    params: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pagination: cloneDeep(defaultPagination),
    };
  },
  methods: {
    /**
     * 페이지 사이즈 변경  이벤트 핸들러
     * @author Ju
     * @param  {[type]} size [description]
     * @return {[type]}      [description]
     */
    onPageSizeChange(size) {
      const nextPagination = {
        ...this.pagination,
        currentPage: 1,
        pageSize: size,
      };
      this.pagination = nextPagination;
      this.$emit('pagination-change', nextPagination);
      this.$emit('condition-change', this.getPageParams());
    },
    /**
     * 현재 페이지를 설정한다.
     * @author Ju
     * @param  {[type]} currentPage [description]
     */
    setCurrentPage(currentPage, slient = false) {
      if (!slient) {
        this.onPageCurrentChange(currentPage);
      } else {
        this.pagination = {
          ...this.pagination,
          currentPage: currentPage || this.pagination.currentPage || 1,
        };
      }
    },
    /**
     * 현재 페이지 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} currentPage [description]
     * @return {[type]}             [description]
     */
    onPageCurrentChange(currentPage) {
      const nextPagination = {
        ...this.pagination,
        currentPage: currentPage || this.pagination.currentPage || 1,
      };
      this.pagination = nextPagination;
      this.$emit('pagination-change', nextPagination);
      this.$emit('condition-change', this.getPageParams());
    },
    /**
     * 페에지 파라미터 객체를 반환한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getPageParams() {
      const pagination = this.pagination;
      const params = {
        start: (pagination.currentPage - 1) * pagination.pageSize,
        limit: pagination.pageSize,
      };
      return isNil(this.params) ? params : {
        ...this.params,
        ...params,
      };
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/SmartSearchPopup/SearchResultView/components/pagination.vue